import { arbitrum, base, mainnet, polygon } from 'viem/chains';

import { ALCHEMY_API_KEY, alchemyDomains } from 'shared/config/config.constants';

import IconArbitrum from 'assets/networks/arbitrum.svg?react';
import IconBaseSepolia from 'assets/networks/baseSepolia.svg?react';
import IconEthereum from 'assets/networks/ethereum.svg?react';
import IconPolygonMumbai from 'assets/networks/polygon.svg?react';

import { SUPPORTED_CHAIN_IDS } from './config.types';

export const CHAINS = {
  mainnet,
  arbitrum,
  polygon,
  base,
};

export const CHAINS_IDS = [mainnet.id, arbitrum.id, polygon.id, base.id];

export const CHAINS_LOGOS = {
  [SUPPORTED_CHAIN_IDS.ARBITRUM]: <IconArbitrum className="h-8 w-8" />,
  [SUPPORTED_CHAIN_IDS.ETHEREUM]: <IconEthereum className="h-8 w-8" />,
  [SUPPORTED_CHAIN_IDS.BASE]: <IconBaseSepolia className="h-8 w-8" />,
  [SUPPORTED_CHAIN_IDS.POLYGON]: <IconPolygonMumbai className="h-8 w-8" />,
};

export const chainIcons: Record<SUPPORTED_CHAIN_IDS, string> = {
  [SUPPORTED_CHAIN_IDS.ARBITRUM]:
    'https://assets.coingecko.com/coins/images/16547/standard/arb.jpg?1721358242',
  [SUPPORTED_CHAIN_IDS.ETHEREUM]:
    'https://assets.coingecko.com/coins/images/279/standard/ethereum.png?1696501628',
  [SUPPORTED_CHAIN_IDS.POLYGON]:
    'https://assets.coingecko.com/coins/images/4713/standard/polygon.png?1698233745',
  [SUPPORTED_CHAIN_IDS.BASE]:
    'https://assets.coingecko.com/nft_contracts/images/2989/small_2x/base-introduced.png?1707289780',
};

const addAlchemyRpc = (chain: any, url: string) => ({
  ...chain,
  rpcUrls: {
    ...chain.rpcUrls,
    default: {
      ...chain.rpcUrls.default,
      http: [...(chain.rpcUrls.default?.http ?? []), url],
    },
    public: {
      ...chain.rpcUrls.public,
      http: [...(chain.rpcUrls.public?.http ?? []), url],
    },
  },
});

const withAlchemyRpc = (chain: any) =>
  addAlchemyRpc(
    chain,
    `https://${alchemyDomains[chain.id as SUPPORTED_CHAIN_IDS]}.g.alchemy.com/v2/${ALCHEMY_API_KEY}`,
  );

const OVERRIDES_LIST = Object.values(CHAINS).map(withAlchemyRpc);
const OVERRIDES_BY_ID = Object.fromEntries(OVERRIDES_LIST.map((c) => [c.id, c]));

export const MAINNET_OVERRIDE = OVERRIDES_BY_ID[mainnet.id];
export const ARBITRUM_OVERRIDE = OVERRIDES_BY_ID[arbitrum.id];
export const POLYGON_OVERRIDE = OVERRIDES_BY_ID[polygon.id];
export const BASE_OVERRIDE = OVERRIDES_BY_ID[base.id];

export const SUPPORTED_CHAINS = [
  BASE_OVERRIDE,
  ARBITRUM_OVERRIDE,
  POLYGON_OVERRIDE,
  MAINNET_OVERRIDE,
];

export const CHAIN_BY_ID = OVERRIDES_BY_ID;
